<template>
  <div class="vs-prompt-form">
    <div class="vx-row mb-5">
      <div class="vx-col sm:w-1/4">
        <img :src="require('@/assets/images/' + form.integration.integrationType.toLowerCase() + '-logo.svg')" class="w-full" />
      </div>
      <div class="vx-col sm:w-3/4">
        <p>{{ form.integration.description }}</p>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 mb-5">
        <label class="vs-input--label">Your API Key</label>
        <span>{{ form.config }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
export default {
  name: 'SalesForceIntegrationForm',
  props: ['data'],
  data() {
    return {
      form: {
        integration: this.data.integration || {},
        config: this.data.config || uuidv4(),
      },
    }
  },
  methods: {
    async submit(rest) {
      if (rest) {
        const isUpdate = this.data.id;
        const dipsatchUrl = isUpdate ? 'updateIntegration' : 'createIntegration';

        return await this.$store.dispatch(`visitManagement/${dipsatchUrl}`, {
          ...(isUpdate && {id: this.data.id}),
          integration: this.form.integration,
          config: this.form.config
        })
          .then(result => result)
          .catch(err => {
            console.error(err);
            return false;
          });
      } else {
        this.$vs.notify({
          title: "Error",
          text: "There is no data to be submitted",
          color: "danger",
          fixed: false
        })
      }
    }
  }
}
</script>
